// Philippine city/province coordinates for the map
export const philippineLocations: { [key: string]: { lat: number; lng: number } } = {
  'Metro Manila': { lat: 14.5995, lng: 120.9842 },
  'Quezon City': { lat: 14.6760, lng: 121.0437 },
  'San Juan City': { lat: 14.6019, lng: 121.0355 },
  'Makati City': { lat: 14.5547, lng: 121.0244 },
  'Pasig City': { lat: 14.5764, lng: 121.0851 },
  'Taguig City': { lat: 14.5176, lng: 121.0509 },
  'Caloocan City': { lat: 14.6499, lng: 120.9809 },
  'Parañaque City': { lat: 14.4793, lng: 121.0198 },
  'Muntinlupa City': { lat: 14.3850, lng: 121.0489 },
  'Las Piñas City': { lat: 14.4504, lng: 120.9825 },
  'Marikina City': { lat: 14.6507, lng: 121.1029 },
  'Pasay City': { lat: 14.5378, lng: 121.0014 },
  'Malabon City': { lat: 14.6681, lng: 120.9658 },
  'Navotas City': { lat: 14.6667, lng: 120.9417 },
  'Valenzuela City': { lat: 14.7011, lng: 120.9830 },
  'Mandaluyong City': { lat: 14.5794, lng: 121.0359 },
  'Cebu City': { lat: 10.3157, lng: 123.8854 },
  'Davao City': { lat: 7.1907, lng: 125.4553 },
  'Baguio City': { lat: 16.4023, lng: 120.5960 },
  'Iloilo City': { lat: 10.7202, lng: 122.5621 },
  'Bacolod City': { lat: 10.6713, lng: 122.9511 },
  
  // Provinces
  'Cebu': { lat: 10.3157, lng: 123.8854 },
  'Davao del Sur': { lat: 7.1907, lng: 125.4553 },
  'Benguet': { lat: 16.4023, lng: 120.5960 },
  'Iloilo': { lat: 10.7202, lng: 122.5621 },
  'Negros Occidental': { lat: 10.6713, lng: 122.9511 }
}; 